
const listColorsReduce = [
    { tw: "bg-red-100", hex: "#FFE2E2" },
    { tw: "bg-red-200", hex: "#FFC9C9" },
    { tw: "bg-red-300", hex: "#FFA2A2" },
    { tw: "bg-red-400", hex: "#FF6467" },
    { tw: "bg-red-500", hex: "#FB2C36" },
    { tw: "bg-red-600", hex: "#E7180B" },
    { tw: "bg-red-700", hex: "#C11007" },
    { tw: "bg-red-800", hex: "#9F0712" },
    { tw: "bg-red-900", hex: "#82181A" },
    { tw: "bg-orange-100", hex: "#FFEDD4" },
    { tw: "bg-orange-200", hex: "#FFD6A7" },
    { tw: "bg-orange-300", hex: "#FFB86A" },
    { tw: "bg-orange-400", hex: "#FF8904" },
    { tw: "bg-orange-500", hex: "#FF692A" },
    { tw: "bg-orange-600", hex: "#F54927" },
    { tw: "bg-orange-700", hex: "#CA3519" },
    { tw: "bg-orange-800", hex: "#9F2D01" },
    { tw: "bg-orange-900", hex: "#7E2A0C" },
    { tw: "bg-yellow-100", hex: "#FEF9C2" },
    { tw: "bg-yellow-200", hex: "#FFF085" },
    { tw: "bg-yellow-300", hex: "#FFDF20" },
    { tw: "bg-yellow-400", hex: "#FDC745" },
    { tw: "bg-yellow-500", hex: "#F0B13B" },
    { tw: "bg-yellow-600", hex: "#D0872E" },
    { tw: "bg-yellow-700", hex: "#A65F1B" },
    { tw: "bg-yellow-800", hex: "#894B0A" },
    { tw: "bg-yellow-900", hex: "#733E0A" },
    { tw: "bg-lime-100", hex: "#ECFCCA" },
    { tw: "bg-lime-200", hex: "#D8F999" },
    { tw: "bg-lime-300", hex: "#BBF451" },
    { tw: "bg-lime-400", hex: "#9AE630" },
    { tw: "bg-lime-500", hex: "#7CCF35" },
    { tw: "bg-lime-600", hex: "#5EA529" },
    { tw: "bg-lime-700", hex: "#497D15" },
    { tw: "bg-lime-800", hex: "#3C6301" },
    { tw: "bg-lime-900", hex: "#35530E" },
    { tw: "bg-green-100", hex: "#DCFCE7" },
    { tw: "bg-green-200", hex: "#B9F8CF" },
    { tw: "bg-green-300", hex: "#7BF1A8" },
    { tw: "bg-green-400", hex: "#05DF72" },
    { tw: "bg-green-500", hex: "#31C950" },
    { tw: "bg-green-600", hex: "#2AA63E" },
    { tw: "bg-green-700", hex: "#178236" },
    { tw: "bg-green-800", hex: "#016630" },
    { tw: "bg-green-900", hex: "#0D542B" },
    { tw: "bg-teal-100", hex: "#CBFBF1" },
    { tw: "bg-teal-200", hex: "#96F7E4" },
    { tw: "bg-teal-300", hex: "#46ECD5" },
    { tw: "bg-teal-400", hex: "#38D5BE" },
    { tw: "bg-teal-500", hex: "#36BBA7" },
    { tw: "bg-teal-600", hex: "#2A9689" },
    { tw: "bg-teal-700", hex: "#18786F" },
    { tw: "bg-teal-800", hex: "#075F5A" },
    { tw: "bg-teal-900", hex: "#0B4F4A" },
    { tw: "bg-cyan-100", hex: "#CEFAFE" },
    { tw: "bg-cyan-200", hex: "#A2F4FD" },
    { tw: "bg-cyan-300", hex: "#53EAFD" },
    { tw: "bg-cyan-400", hex: "#42D3F2" },
    { tw: "bg-cyan-500", hex: "#3BB8DB" },
    { tw: "bg-cyan-600", hex: "#2C92B8" },
    { tw: "bg-cyan-700", hex: "#1A7595" },
    { tw: "bg-cyan-800", hex: "#015F78" },
    { tw: "bg-cyan-900", hex: "#104E64" },
    { tw: "bg-blue-100", hex: "#DBEAFE" },
    { tw: "bg-blue-200", hex: "#BEDBFF" },
    { tw: "bg-blue-300", hex: "#8EC5FF" },
    { tw: "bg-blue-400", hex: "#51A2FF" },
    { tw: "bg-blue-500", hex: "#2B7FFF" },
    { tw: "bg-blue-600", hex: "#155DFC" },
    { tw: "bg-blue-700", hex: "#1447E6" },
    { tw: "bg-blue-800", hex: "#193CB8" },
    { tw: "bg-blue-900", hex: "#1C398E" },
    { tw: "bg-violet-100", hex: "#EDE9FE" },
    { tw: "bg-violet-200", hex: "#DDD6FF" },
    { tw: "bg-violet-300", hex: "#C4B4FF" },
    { tw: "bg-violet-400", hex: "#A684FF" },
    { tw: "bg-violet-500", hex: "#8E51FF" },
    { tw: "bg-violet-600", hex: "#7F22FE" },
    { tw: "bg-violet-700", hex: "#7008E7" },
    { tw: "bg-violet-800", hex: "#5D0EC0" },
    { tw: "bg-violet-900", hex: "#4D179A" },
    { tw: "bg-purple-100", hex: "#F3E8FF" },
    { tw: "bg-purple-200", hex: "#E9D4FF" },
    { tw: "bg-purple-300", hex: "#DAB2FF" },
    { tw: "bg-purple-400", hex: "#C27AFF" },
    { tw: "bg-purple-500", hex: "#AD46FF" },
    { tw: "bg-purple-600", hex: "#9810FA" },
    { tw: "bg-purple-700", hex: "#8207DB" },
    { tw: "bg-purple-800", hex: "#6E11B0" },
    { tw: "bg-purple-900", hex: "#59168B" },
    { tw: "bg-pink-100", hex: "#FCE7F3" },
    { tw: "bg-pink-200", hex: "#FCCEE8" },
    { tw: "bg-pink-300", hex: "#FDA5D5" },
    { tw: "bg-pink-400", hex: "#FB64B6" },
    { tw: "bg-pink-500", hex: "#F6339A" },
    { tw: "bg-pink-600", hex: "#E61876" },
    { tw: "bg-pink-700", hex: "#C6185C" },
    { tw: "bg-pink-800", hex: "#A3044C" },
    { tw: "bg-pink-900", hex: "#861043" },
    { tw: "bg-slate-100", hex: "#F1F5F9" },
    { tw: "bg-slate-200", hex: "#E2E8F0" },
    { tw: "bg-slate-300", hex: "#CAD5E2" },
    { tw: "bg-slate-400", hex: "#90A1B9" },
    { tw: "bg-slate-500", hex: "#62748E" },
    { tw: "bg-slate-600", hex: "#45556C" },
    { tw: "bg-slate-700", hex: "#314158" },
    { tw: "bg-slate-800", hex: "#1D293D" },
    { tw: "bg-slate-900", hex: "#0F172B" },
    { tw: "bg-stone-100", hex: "#F5F5F4" },
    { tw: "bg-stone-200", hex: "#E7E5E4" },
    { tw: "bg-stone-300", hex: "#D6D3D1" },
    { tw: "bg-stone-400", hex: "#A6A09B" },
    { tw: "bg-stone-500", hex: "#79716B" },
    { tw: "bg-stone-600", hex: "#57534D" },
    { tw: "bg-stone-700", hex: "#44403B" },
    { tw: "bg-stone-800", hex: "#292524" },
    { tw: "bg-stone-900", hex: "#1C1917" },
]

const listColorsFull = [
    { tw: "bg-red-50", hex: "#FEF2F2" },
    { tw: "bg-red-100", hex: "#FFE2E2" },
    { tw: "bg-red-200", hex: "#FFC9C9" },
    { tw: "bg-red-300", hex: "#FFA2A2" },
    { tw: "bg-red-400", hex: "#FF6467" },
    { tw: "bg-red-500", hex: "#FB2C36" },
    { tw: "bg-red-600", hex: "#E7180B" },
    { tw: "bg-red-700", hex: "#C11007" },
    { tw: "bg-red-800", hex: "#9F0712" },
    { tw: "bg-red-900", hex: "#82181A" },
    { tw: "bg-red-950", hex: "#460809" },
    { tw: "bg-orange-50", hex: "#FFF7ED" },
    { tw: "bg-orange-100", hex: "#FFEDD4" },
    { tw: "bg-orange-200", hex: "#FFD6A7" },
    { tw: "bg-orange-300", hex: "#FFB86A" },
    { tw: "bg-orange-400", hex: "#FF8904" },
    { tw: "bg-orange-500", hex: "#FF692A" },
    { tw: "bg-orange-600", hex: "#F54927" },
    { tw: "bg-orange-700", hex: "#CA3519" },
    { tw: "bg-orange-800", hex: "#9F2D01" },
    { tw: "bg-orange-900", hex: "#7E2A0C" },
    { tw: "bg-orange-950", hex: "#441306" },
    { tw: "bg-amber-50", hex: "#FFFBEB" },
    { tw: "bg-amber-100", hex: "#FEF3C6" },
    { tw: "bg-amber-200", hex: "#FEE685" },
    { tw: "bg-amber-300", hex: "#FFD230" },
    { tw: "bg-amber-400", hex: "#FFB93B" },
    { tw: "bg-amber-500", hex: "#FE9A37" },
    { tw: "bg-amber-600", hex: "#E1712B" },
    { tw: "bg-amber-700", hex: "#BB4D1A" },
    { tw: "bg-amber-800", hex: "#973C08" },
    { tw: "bg-amber-900", hex: "#7B3306" },
    { tw: "bg-amber-950", hex: "#461901" },
    { tw: "bg-yellow-50", hex: "#FEFCE8" },
    { tw: "bg-yellow-100", hex: "#FEF9C2" },
    { tw: "bg-yellow-200", hex: "#FFF085" },
    { tw: "bg-yellow-300", hex: "#FFDF20" },
    { tw: "bg-yellow-400", hex: "#FDC745" },
    { tw: "bg-yellow-500", hex: "#F0B13B" },
    { tw: "bg-yellow-600", hex: "#D0872E" },
    { tw: "bg-yellow-700", hex: "#A65F1B" },
    { tw: "bg-yellow-800", hex: "#894B0A" },
    { tw: "bg-yellow-900", hex: "#733E0A" },
    { tw: "bg-yellow-950", hex: "#432004" },
    { tw: "bg-lime-50", hex: "#F7FEE7" },
    { tw: "bg-lime-100", hex: "#ECFCCA" },
    { tw: "bg-lime-200", hex: "#D8F999" },
    { tw: "bg-lime-300", hex: "#BBF451" },
    { tw: "bg-lime-400", hex: "#9AE630" },
    { tw: "bg-lime-500", hex: "#7CCF35" },
    { tw: "bg-lime-600", hex: "#5EA529" },
    { tw: "bg-lime-700", hex: "#497D15" },
    { tw: "bg-lime-800", hex: "#3C6301" },
    { tw: "bg-lime-900", hex: "#35530E" },
    { tw: "bg-lime-950", hex: "#192E03" },
    { tw: "bg-green-50", hex: "#F0FDF4" },
    { tw: "bg-green-100", hex: "#DCFCE7" },
    { tw: "bg-green-200", hex: "#B9F8CF" },
    { tw: "bg-green-300", hex: "#7BF1A8" },
    { tw: "bg-green-400", hex: "#05DF72" },
    { tw: "bg-green-500", hex: "#31C950" },
    { tw: "bg-green-600", hex: "#2AA63E" },
    { tw: "bg-green-700", hex: "#178236" },
    { tw: "bg-green-800", hex: "#016630" },
    { tw: "bg-green-900", hex: "#0D542B" },
    { tw: "bg-green-950", hex: "#032E15" },
    { tw: "bg-emerald-50", hex: "#ECFDF5" },
    { tw: "bg-emerald-100", hex: "#D0FAE5" },
    { tw: "bg-emerald-200", hex: "#A4F4CF" },
    { tw: "bg-emerald-300", hex: "#5EE9B5" },
    { tw: "bg-emerald-400", hex: "#31D492" },
    { tw: "bg-emerald-500", hex: "#37BC7D" },
    { tw: "bg-emerald-600", hex: "#2D9966" },
    { tw: "bg-emerald-700", hex: "#1F7A55" },
    { tw: "bg-emerald-800", hex: "#116045" },
    { tw: "bg-emerald-900", hex: "#034F3B" },
    { tw: "bg-emerald-950", hex: "#012C22" },
    { tw: "bg-teal-50", hex: "#F0FDFA" },
    { tw: "bg-teal-100", hex: "#CBFBF1" },
    { tw: "bg-teal-200", hex: "#96F7E4" },
    { tw: "bg-teal-300", hex: "#46ECD5" },
    { tw: "bg-teal-400", hex: "#38D5BE" },
    { tw: "bg-teal-500", hex: "#36BBA7" },
    { tw: "bg-teal-600", hex: "#2A9689" },
    { tw: "bg-teal-700", hex: "#18786F" },
    { tw: "bg-teal-800", hex: "#075F5A" },
    { tw: "bg-teal-900", hex: "#0B4F4A" },
    { tw: "bg-teal-950", hex: "#022F2E" },
    { tw: "bg-cyan-50", hex: "#ECFEFF" },
    { tw: "bg-cyan-100", hex: "#CEFAFE" },
    { tw: "bg-cyan-200", hex: "#A2F4FD" },
    { tw: "bg-cyan-300", hex: "#53EAFD" },
    { tw: "bg-cyan-400", hex: "#42D3F2" },
    { tw: "bg-cyan-500", hex: "#3BB8DB" },
    { tw: "bg-cyan-600", hex: "#2C92B8" },
    { tw: "bg-cyan-700", hex: "#1A7595" },
    { tw: "bg-cyan-800", hex: "#015F78" },
    { tw: "bg-cyan-900", hex: "#104E64" },
    { tw: "bg-cyan-950", hex: "#053345" },
    { tw: "bg-sky-50", hex: "#F0F9FF" },
    { tw: "bg-sky-100", hex: "#DFF2FE" },
    { tw: "bg-sky-200", hex: "#B8E6FE" },
    { tw: "bg-sky-300", hex: "#74D4FF" },
    { tw: "bg-sky-400", hex: "#21BCFF" },
    { tw: "bg-sky-500", hex: "#34A6F4" },
    { tw: "bg-sky-600", hex: "#2984D1" },
    { tw: "bg-sky-700", hex: "#1C69A8" },
    { tw: "bg-sky-800", hex: "#10598A" },
    { tw: "bg-sky-900", hex: "#024A70" },
    { tw: "bg-sky-950", hex: "#052F4A" },
    { tw: "bg-blue-50", hex: "#EFF6FF" },
    { tw: "bg-blue-100", hex: "#DBEAFE" },
    { tw: "bg-blue-200", hex: "#BEDBFF" },
    { tw: "bg-blue-300", hex: "#8EC5FF" },
    { tw: "bg-blue-400", hex: "#51A2FF" },
    { tw: "bg-blue-500", hex: "#2B7FFF" },
    { tw: "bg-blue-600", hex: "#155DFC" },
    { tw: "bg-blue-700", hex: "#1447E6" },
    { tw: "bg-blue-800", hex: "#193CB8" },
    { tw: "bg-blue-900", hex: "#1C398E" },
    { tw: "bg-blue-950", hex: "#162456" },
    { tw: "bg-indigo-50", hex: "#EEF2FF" },
    { tw: "bg-indigo-100", hex: "#E0E7FF" },
    { tw: "bg-indigo-200", hex: "#C6D2FF" },
    { tw: "bg-indigo-300", hex: "#A3B3FF" },
    { tw: "bg-indigo-400", hex: "#7C86FF" },
    { tw: "bg-indigo-500", hex: "#615FFF" },
    { tw: "bg-indigo-600", hex: "#4F39F6" },
    { tw: "bg-indigo-700", hex: "#432DD7" },
    { tw: "bg-indigo-800", hex: "#372AAC" },
    { tw: "bg-indigo-900", hex: "#312C85" },
    { tw: "bg-indigo-950", hex: "#1E1A4D" },
    { tw: "bg-violet-50", hex: "#F5F3FF" },
    { tw: "bg-violet-100", hex: "#EDE9FE" },
    { tw: "bg-violet-200", hex: "#DDD6FF" },
    { tw: "bg-violet-300", hex: "#C4B4FF" },
    { tw: "bg-violet-400", hex: "#A684FF" },
    { tw: "bg-violet-500", hex: "#8E51FF" },
    { tw: "bg-violet-600", hex: "#7F22FE" },
    { tw: "bg-violet-700", hex: "#7008E7" },
    { tw: "bg-violet-800", hex: "#5D0EC0" },
    { tw: "bg-violet-900", hex: "#4D179A" },
    { tw: "bg-violet-950", hex: "#2F0D68" },
    { tw: "bg-purple-50", hex: "#FAF5FF" },
    { tw: "bg-purple-100", hex: "#F3E8FF" },
    { tw: "bg-purple-200", hex: "#E9D4FF" },
    { tw: "bg-purple-300", hex: "#DAB2FF" },
    { tw: "bg-purple-400", hex: "#C27AFF" },
    { tw: "bg-purple-500", hex: "#AD46FF" },
    { tw: "bg-purple-600", hex: "#9810FA" },
    { tw: "bg-purple-700", hex: "#8207DB" },
    { tw: "bg-purple-800", hex: "#6E11B0" },
    { tw: "bg-purple-900", hex: "#59168B" },
    { tw: "bg-purple-950", hex: "#3C0366" },
    { tw: "bg-fuchsia-50", hex: "#FDF4FF" },
    { tw: "bg-fuchsia-100", hex: "#FAE8FF" },
    { tw: "bg-fuchsia-200", hex: "#F6CFFF" },
    { tw: "bg-fuchsia-300", hex: "#F4A8FF" },
    { tw: "bg-fuchsia-400", hex: "#ED6AFF" },
    { tw: "bg-fuchsia-500", hex: "#E12AFB" },
    { tw: "bg-fuchsia-600", hex: "#C81CDE" },
    { tw: "bg-fuchsia-700", hex: "#A813B7" },
    { tw: "bg-fuchsia-800", hex: "#8A0194" },
    { tw: "bg-fuchsia-900", hex: "#721378" },
    { tw: "bg-fuchsia-950", hex: "#4B004F" },
    { tw: "bg-pink-50", hex: "#FDF2F8" },
    { tw: "bg-pink-100", hex: "#FCE7F3" },
    { tw: "bg-pink-200", hex: "#FCCEE8" },
    { tw: "bg-pink-300", hex: "#FDA5D5" },
    { tw: "bg-pink-400", hex: "#FB64B6" },
    { tw: "bg-pink-500", hex: "#F6339A" },
    { tw: "bg-pink-600", hex: "#E61876" },
    { tw: "bg-pink-700", hex: "#C6185C" },
    { tw: "bg-pink-800", hex: "#A3044C" },
    { tw: "bg-pink-900", hex: "#861043" },
    { tw: "bg-pink-950", hex: "#510424" },
    { tw: "bg-rose-50", hex: "#FFF1F2" },
    { tw: "bg-rose-100", hex: "#FFE4E6" },
    { tw: "bg-rose-200", hex: "#FFCCD3" },
    { tw: "bg-rose-300", hex: "#FFA1AD" },
    { tw: "bg-rose-400", hex: "#FF637E" },
    { tw: "bg-rose-500", hex: "#FF2056" },
    { tw: "bg-rose-600", hex: "#EC253F" },
    { tw: "bg-rose-700", hex: "#C71D36" },
    { tw: "bg-rose-800", hex: "#A50C36" },
    { tw: "bg-rose-900", hex: "#8B0836" },
    { tw: "bg-rose-950", hex: "#4D0218" },
    { tw: "bg-slate-50", hex: "#F8FAFC" },
    { tw: "bg-slate-100", hex: "#F1F5F9" },
    { tw: "bg-slate-200", hex: "#E2E8F0" },
    { tw: "bg-slate-300", hex: "#CAD5E2" },
    { tw: "bg-slate-400", hex: "#90A1B9" },
    { tw: "bg-slate-500", hex: "#62748E" },
    { tw: "bg-slate-600", hex: "#45556C" },
    { tw: "bg-slate-700", hex: "#314158" },
    { tw: "bg-slate-800", hex: "#1D293D" },
    { tw: "bg-slate-900", hex: "#0F172B" },
    { tw: "bg-slate-950", hex: "#020618" },
    { tw: "bg-gray-50", hex: "#F9FAFB" },
    { tw: "bg-gray-100", hex: "#F3F4F6" },
    { tw: "bg-gray-200", hex: "#E5E7EB" },
    { tw: "bg-gray-300", hex: "#D1D5DC" },
    { tw: "bg-gray-400", hex: "#99A1AF" },
    { tw: "bg-gray-500", hex: "#6A7282" },
    { tw: "bg-gray-600", hex: "#4A5565" },
    { tw: "bg-gray-700", hex: "#364153" },
    { tw: "bg-gray-800", hex: "#1E2939" },
    { tw: "bg-gray-900", hex: "#101828" },
    { tw: "bg-gray-950", hex: "#030712" },
    { tw: "bg-zinc-50", hex: "#FAFAFA" },
    { tw: "bg-zinc-100", hex: "#F4F4F5" },
    { tw: "bg-zinc-200", hex: "#E4E4E7" },
    { tw: "bg-zinc-300", hex: "#D4D4D8" },
    { tw: "bg-zinc-400", hex: "#9F9FA9" },
    { tw: "bg-zinc-500", hex: "#71717B" },
    { tw: "bg-zinc-600", hex: "#52525C" },
    { tw: "bg-zinc-700", hex: "#3F3F46" },
    { tw: "bg-zinc-800", hex: "#27272A" },
    { tw: "bg-zinc-900", hex: "#18181B" },
    { tw: "bg-zinc-950", hex: "#09090B" },
    { tw: "bg-neutral-50", hex: "#FAFAFA" },
    { tw: "bg-neutral-100", hex: "#F5F5F5" },
    { tw: "bg-neutral-200", hex: "#E5E5E5" },
    { tw: "bg-neutral-300", hex: "#D4D4D4" },
    { tw: "bg-neutral-400", hex: "#A1A1A1" },
    { tw: "bg-neutral-500", hex: "#737373" },
    { tw: "bg-neutral-600", hex: "#525252" },
    { tw: "bg-neutral-700", hex: "#404040" },
    { tw: "bg-neutral-800", hex: "#262626" },
    { tw: "bg-neutral-900", hex: "#171717" },
    { tw: "bg-neutral-950", hex: "#0A0A0A" },
    { tw: "bg-stone-50", hex: "#FAFAF9" },
    { tw: "bg-stone-100", hex: "#F5F5F4" },
    { tw: "bg-stone-200", hex: "#E7E5E4" },
    { tw: "bg-stone-300", hex: "#D6D3D1" },
    { tw: "bg-stone-400", hex: "#A6A09B" },
    { tw: "bg-stone-500", hex: "#79716B" },
    { tw: "bg-stone-600", hex: "#57534D" },
    { tw: "bg-stone-700", hex: "#44403B" },
    { tw: "bg-stone-800", hex: "#292524" },
    { tw: "bg-stone-900", hex: "#1C1917" },
    { tw: "bg-stone-950", hex: "#0C0A09" },
]

const listColors = (all) => {
    return (all === true) ? listColorsFull : listColorsReduce;
}

export const ColorPicker = (props) => {
    const { setColor, closeModal, full } = props;
    return (
        <div className="fixed lg:relative inset-0 flex z-40 bg-black/40 lg:bg-none" onClick={closeModal}>
            <div className={`fixed z-50 lg:absolute w-full h:full lg:w-auto lg:h-auto p-2 grid ${full === true ? "grid-rows-11" : "grid-rows-9"} grid-flow-col gap-1 bg-white border`}>
                {listColors(full).map((color, index) => (
                    <div key={index} className={`${color.tw} rounded h-8 lg:h-6 w-auto lg:w-6 cursor-pointer`} onClick={() => setColor(color.hex)}></div>
                ))}
            </div>
        </div >
    );
}